<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增字段</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="800px"
          :title="isEdit ? '修改字段' : '新增字段'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="字段名：" prop="field_name">
                <el-input v-model="formData.field_name" placeholder="请输入字段名" clearable></el-input>
              </el-form-item>
              <el-form-item label="字段类型：" prop="field_type">
                <el-select
                  v-model="formData.field_type"
                  filterable
                  clearable
                  placeholder="请选择字段类型"
                >
                  <el-option
                    v-for="item in fieldList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="字段规范" v-if="formData.field_type">
                <div v-if="(formData.field_type == '枚举单选') || formData.field_type == '枚举多选'">
                  <span style="float:left">枚举选项：</span>
                  <div class="field_li" v-for="(item,index) in fieldTagList" :key="index">
                    <div class="field_li_icon el-icon-circle-close" @click="fieldDel(index)"></div>
                    <span>{{item.text}}</span>
                  </div>
                  <el-input v-model="addFieldVal"></el-input>
                  <el-button style="margin-left: 10px" type="primary" @click="addFieldFn">新增</el-button>
                </div>
                <div v-if="(formData.field_type == '下拉单选')">
                  <span style="float:left">选项库：</span>
                  <el-select
                    v-model="selectVal"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in selectList"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div v-if="formData.field_type == '下拉多选'">
                  <span style="float:left">选项库：</span>
                  <el-select
                    v-model="selectValArr"
                    filterable
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in selectList"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div v-if="formData.field_type == '简单文本输入'">
                  <span style="float:left">字数限制：</span>
                  <el-input v-model="formData.field_length"></el-input>
                  <span style="margin-left: 5px">字</span>
                </div>

                <div v-if="formData.field_type == '时间选择器'">
                  <span style="float:left">精准度：</span>
                  <el-select
                    v-model="timeVal"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in timeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div v-if="formData.field_type == '图片上传'">
                  <span style="float:left">数量限制：</span>
                  <el-input v-model="formData.field_length"></el-input>
                  <span style="margin-left: 5px">张</span>
                </div>
                <div v-if="formData.field_type == '视频上传'">
                  <span style="float:left">数量限制：</span>
                  <el-input v-model="formData.field_length"></el-input>
                  <span style="margin-left: 5px">个</span>
                </div>
                <div v-if="formData.field_type == '人数统计'">
                  <!-- <span style="float:left">数量限制：</span>
                  <el-input v-model="formData.field_length"></el-input>
                  <span style="margin-left: 5px">人</span> -->
                </div>
                <div v-if="formData.field_type == '联动单选'">
                  <span style="float:left">选项库：</span>
                  <el-select
                    v-model="linkageVal"
                    filterable
                    clearable
                  >
                    <el-option
                      label="事件类型库"
                      value="事件类型库"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div v-if="formData.field_type == '联动多选'">
                  <span style="float:left">选项库：</span>
                  <el-select
                    v-model="linkageValArr"
                    filterable
                    multiple
                    clearable
                  >
                    <el-option
                      label="事件类型库"
                      value="事件类型库"
                    >
                    </el-option>
                    <el-option
                      label="统计类型库"
                      value="统计类型库"
                    >
                    </el-option>
                  </el-select>
                </div>

              </el-form-item>

            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button v-if="isEdit" type="primary" @click="editFormFn">确定</el-button>
            <el-button v-else type="primary" @click="submitFormFn">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import baseApi from "@/api/baseApi";
import dataAnalysisApi from "@/views/data-analysis/api";
import api from "./api";
import TipUtil from "@/utils/utils/TipUtil";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AppList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.fieldConfigList,
        hidePagination: true,
        query: {

        },
        searchData: [
          {
            type: "input",
            model: "id",
            placeholder: "字段ID"
          },
          {
            type: "select",
            model: "article_category_id",
            placeholder: "所属分类",
            api: api.categoryList,
            keyValueName: ["id", "category_name"]
          },
          {
            type: "input",
            model: "field_name",
            placeholder: "字段名"
          }
        ],

        columns: [
          {
            title: "字段名",
            key: "field_name",
            minWidth:"100",
            showTooltip: true
          },
          {
            title: "字段形式",
            key: "field_type",
            minWidth:"100",
            showTooltip: true
          },
          {
            title: "形式说明",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", ctx.row.field_length == 0 ? ctx.row.field_config_data == null ?'不限':ctx.row.field_config_data.multi_select == true ? '多选':'单选':'字符限制'+ctx.row.field_length+'字');
            }
          },
          {
            title: "创建时间",
            key: "add_time",
            minWidth:"150",
            showTooltip: true,
            render(h, ctx) {
              return h("span", vm.$commFunc.formatDate(ctx.row.add_time));
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "160",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status + " " + vm.$commFunc.formatDate(ctx.row.last_admin_time);
              }
              return h("span", statusText);
            }
          },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEditFn.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"
              );

              let arr = [];
              arr.push(editBtn);

              // arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
      },
      formRules: {
        field_name: {
          required: true,
          message: "字段名不能为空",
          trigger: "blur"
        },
        field_type: {
          required: true,
          message: "字段类型不能为空",
          trigger: "change"
        }
      },
      fieldList: [
        {label: "枚举单选"},
        {label: "枚举多选"},
        {label: "下拉单选"},
        {label: "下拉多选"},
        {label: "简单文本输入"},
        {label: "富文本输入"},
        {label: "时间选择器"},
        {label: "地址单个输入"},
        {label: "地址多个输入"},
        {label: "人数统计"},
        {label: "图片上传"},
        {label: "视频上传"},
        {label: "联动单选"},
        {label: "联动多选"},
      ],
      adddApi: api.addCollectSource,
      editApi: api.editCollectSource,
      deleteApi: api.deleteCollectSource,
      addSuccessMsg: '添加采集源成功',
      editSuccessMsg: '编辑采集源成功',
      deleteSuccessMsg: '删除采集源成功',
      addFieldVal: '',
      fieldTagList: [],
      selectVal: '',
      selectValArr: [],
      linkageVal: '', //联动下拉菜单默认值
      linkageValArr: [],
      selectList: [
        {label: "地区库"},
        {label: "事件类型库"},
        {label: "影响等级库"},
        {label: "风险等级库"},
      ],
      timeVal: '',
      timeList: [
        {label: "时分秒", value: "YMDHNS"},
        {label: "年月日", value: "YMD"},
      ],
      editId: '',
      isEdit: false
    };
  },

  computed: {

  },

  methods: {
    addFieldFn() {
      this.fieldTagList.push({text: this.addFieldVal})
      this.addFieldVal = ""
    },
    // 删除枚举字段
    fieldDel(index) {
      this.fieldTagList.splice(index,1)
      console.log(index)
    },
    submitFormFn() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          switch (this.formData.field_type) {
            case "枚举单选":
              this.formData.config_data = JSON.stringify({
                "options": this.fieldTagList,
                "multi_select": false
              })
              break;
            case "枚举多选":
              this.formData.config_data = JSON.stringify({
                "options": this.fieldTagList,
                "multi_select": true
              })
              break;
            case "下拉单选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.selectVal,
                "multi_select": false
              })
              break;
            case "下拉多选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.selectValArr.join("/"),
                "multi_select": true
              })
              break;
            case "联动单选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.linkageVal,
                "multi_select": false
              })
              break;
            case "联动多选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.linkageValArr.join("/"),
                "multi_select": true
              })
              break;
            case "时间选择器":
              this.formData.config_data = JSON.stringify({
                "format": this.timeVal
              })
              break;
          
            default:
              break;
          }
          api
          .fieldConfigAdd(this.formData)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("新增成功!")
              this.showFormDialog = false
              this.$refs.dataTable.refresh()
            }
          })
          .catch(err => {
            // console.log(err);
          });
        } else {
          
        }
      });
    },
    editFormFn() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          this.$set(this.formData,"id",this.editId)
          switch (this.formData.field_type) {
            case "枚举单选":
              this.formData.config_data = JSON.stringify({
                "options": this.fieldTagList,
                "multi_select": false
              })
              break;
            case "枚举多选":
              this.formData.config_data = JSON.stringify({
                "options": this.fieldTagList,
                "multi_select": true
              })
              break;
            case "下拉单选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.selectVal,
                "multi_select": false
              })
              break;
            case "下拉多选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.selectValArr.join("/"),
                "multi_select": true
              })
              break;
            case "联动单选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.linkageVal,
                "multi_select": false
              })
              break;
            case "联动多选":
              this.formData.config_data = JSON.stringify({
                "options_lib": this.linkageValArr.join("/"),
                "multi_select": true
              })
              break;
            case "时间选择器":
              this.formData.config_data = JSON.stringify({
                "format": this.timeVal
              })
              break;
          
            default:
              break;
          }
          api
          .fieldConfigEdit(this.formData)
          .then(res => {
            if(res.error_code == 0) {
              this.$message.success("修改成功!")
              this.showFormDialog = false
              this.$refs.dataTable.refresh()
            }
          })
          .catch(err => {
            // console.log(err);
          });
        } else {
          
        }
      });
    },

    doEditFn(rows) {
      this.isEdit = true
      this.showFormDialog = true
      this.editId = rows.id
      this.$set(this.formData,"field_name",rows.field_name)
      this.$set(this.formData,"field_type",rows.field_type)
      this.$set(this.formData,"field_length",rows.field_length)
      switch (this.formData.field_type) {
          case "枚举单选":
             this.fieldTagList = rows.field_config_data.options
            break;
          case "枚举多选":
            this.fieldTagList = rows.field_config_data.options
            break;
          case "下拉单选":
            this.selectVal = rows.field_config_data.options_lib
            break;
          case "下拉多选":
            this.selectValArr = rows.field_config_data.options_lib.split("/")
            break;
          case "时间选择器":
            this.timeVal = rows.field_config_data.format
            break;
        
          default:
            break;
        }
    }
  },

  created() {
    // 获取国家信息
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>
  .field_li {
    position: relative;
    float: left;
    padding: 0px 8px;
    margin: 0 5px;
    border: 1px solid #DCDFE6;
    .field_li_icon {
      position: absolute;
      right: 0px;
      top: 0px;
      cursor: pointer;
    }
  }
</style>
